// assets/duty-messages.js
(() => {
  // --- CONFIG --- //
  const CONFIG = {
    EU: [
      "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT",
      "NL","PL","PT","RO","SK","SI","ES","SE"
    ],
    EU_MESSAGE: "Orders over €150 shipped to the EU may incur local import duties and VAT upon delivery. Orders under €150 are VAT-inclusive and delivered duty-paid.",
    GBP_THRESHOLD: 127, // buffer for €150 conversion
    US: ["US"],
    US_MESSAGE: "Good news for our US customers: All duties & customs are already covered in your shipping cost. Your socks will ship via FedEx, with no extra fees at delivery."
  };

  const userCountry = (window.__COUNTRY__ || "").toUpperCase();

  function renderMessage(type, show) {
    const targets = document.querySelectorAll('[data-eu-warning-target]');
    if (!targets.length) return;

    const className = type === "EU" ? "eu-vat-warning" : "us-shipping-note";
    const message = type === "EU" ? CONFIG.EU_MESSAGE : CONFIG.US_MESSAGE;
    const styles = type === "EU"
      ? { bg: "#fff4e5", border: "#f0c36d", color: "#000" }
      : { bg: "#f0f9f4", border: "#4caf50", color: "#2e7d32" };

    targets.forEach(container => {
      let el = container.querySelector("." + className);
      if (show) {
        if (!el) {
          el = document.createElement("div");
          el.className = className;
          el.setAttribute("role", "alert");
          // inline styling (safe across Shopify themes)
          el.style.background = styles.bg;
          el.style.border = `1px solid ${styles.border}`;
          el.style.borderRadius = "8px";
          el.style.padding = "12px";
          el.style.marginTop = "10px";
          el.style.fontSize = "14px";
          el.style.color = styles.color;
          el.textContent = message;
          container.appendChild(el);
        }
      } else if (el) {
        el.remove();
      }
    });
  }

  async function checkAndUpdate() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();
      const totalGBP = cart.total_price / 100; // Shopify returns cents of shop currency (GBP here)

      const showEU = CONFIG.EU.includes(userCountry) && totalGBP > CONFIG.GBP_THRESHOLD;
      const showUS = CONFIG.US.includes(userCountry);

      renderMessage("EU", showEU);
      renderMessage("US", showUS);
    } catch (e) {
      // fail quietly
    }
  }

  // Debounce helper
  const debounce = (fn, d = 300) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), d); };
  };
  const recheck = debounce(checkAndUpdate, 350);

  // Initial run
  checkAndUpdate();

  // Re-run on common cart interactions
  document.addEventListener("change", e => {
    if (e.target.closest('form[action^="/cart"]')) recheck();
  });
  document.addEventListener("click", e => {
    if (
      e.target.closest('button[name="plus"]') ||
      e.target.closest('button[name="minus"]') ||
      e.target.closest('button[name="update"]') ||
      e.target.closest('a[href^="/cart/change"]') ||
      e.target.closest('button[type="submit"][name="checkout"]')
    ) {
      recheck();
    }
  });

  // Catch-all for drawer DOM swaps
  const observer = new MutationObserver(() => recheck());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();